import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import i18n from 'simple-react-i18n'
import { H_CAMPAIGN_HYDRO_DASHBOARD, H_CAMPAIGN_HYDRO_TRACKING } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CityAction from '../../../referencial/components/city/actions/CityAction'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import HydrometryAction from '../../actions/HydrometryAction'
import { Box, Card, CardContent, Stack } from '@mui/material'
import ProgressBar from 'components/progress/ProgressBar'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import ContactAction from 'referencial/components/contact/actions/ContactAction'
import ReferencialAction from 'referencial/action/ReferencialAction'

const HydrometryCampaignApp = ({}) => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const links = id !== 'new' ? [
        {
            href: `/hydrometry/campaign/${id}/dashboard`,
            icons: 'dashboard',
            name: i18n.dashboard,
            habilitation: H_CAMPAIGN_HYDRO_DASHBOARD,
        },
        {
            href: `/hydrometry/campaign/${id}/tracking`,
            icons: 'insert_drive_file',
            name: i18n.tracking,
            habilitation: H_CAMPAIGN_HYDRO_TRACKING,
        },
        {
            href: `/hydrometry/campaign/${id}/picture`,
            icons: 'perm_media',
            name: i18n.picturesAndDocuments,
            habilitation: H_CAMPAIGN_HYDRO_DASHBOARD,
        },
    ] : [{
        href: `/hydrometry/campaign/${id}/dashboard`,
        icons: 'dashboard',
        name: i18n.dashboard,
        habilitation: H_CAMPAIGN_HYDRO_DASHBOARD,
    }].filter(l => componentHasHabilitations(l.habilitation))

    useEffect(() => {
        return () => {
            dispatch(CampaignAction.resetCampaign())
        }
    }, [])

    const { progress, isLoaded } = useProgressDispatch(() => {
        const campaignFetch = id !== 'new' ?
            [
                dispatch(CampaignAction.fetchCampaign('hydrometry', id)),
                dispatch(CampaignAction.fetchCampaignStation('hydrometry', id)),
                dispatch(CampaignAction.fetchCampaignProgress('hydrometry', id)),
                dispatch(CampaignAction.fetchStationCampaignDetails('hydrometry', id)),
            ]
            :
            []
        return [
            dispatch(HydrometryAction.fetchHydrometricStations()),
            dispatch(CityAction.fetchCities()),
            dispatch(ContactAction.fetchContacts()),
            dispatch(ReferencialAction.fetchSandreCodes()),
            ...campaignFetch,
        ]
    }, [id])

    return (
        <Box>
            <FixedSlideNav links={links} />
            <Box padding={1} className='content-page fullscreen'>
                <BoundaryError>
                    {isLoaded ?
                        <Outlet />
                        :
                        <Stack padding={1}>
                            <Card>
                                <CardContent>
                                    <ProgressBar progress={progress} withMessage />
                                </CardContent>
                            </Card>
                        </Stack>
                    }
                </BoundaryError>
            </Box>
        </Box>
    )
}

export default HydrometryCampaignApp
